export default "__VITE_ASSET__C2Q_f7LW__"